var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"contents"},[_c('BaseHeader',{attrs:{"title":"ログ一覧"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }